import {load} from '@shopify/theme-sections';

import '../sections/featured-collection-slider';
import '../sections/most-loved-blog-posts';

import karmoonSelect from '../components/karmoon-select';
import Article from '../snippets/article-slider';
import ArticleCollectionSlider from '../sections/article-collection-slider';
import ArticleVideos from '../snippets/article-videos';
import Filter from '../sections/filter';

if (document.body.classList.contains('template-article')) {
  karmoonSelect();
  Article().init();
  ArticleCollectionSlider().init();
  ArticleVideos().init();

  Filter().init();

  load('*');
}
